import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';
import Dialog         from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import IconButton     from '@material-ui/core/IconButton';
import Slider         from '@material-ui/core/Slider';
import Tooltip        from '@material-ui/core/Tooltip';

import CloseIcon from '@material-ui/icons/Close';
import ImageIcon from '@material-ui/icons/Image';

import { create } from '../util';

const style = {
  newPicture: makeStyles((theme) => ({
    dialogContent: {
      backgroundColor: 'lightgray',
      padding: '0!important',
    },
  })),
};

export default function NewPicture(props) {
  const classes = style.newPicture();

  const [image, setImage] = React.useState({height: 0, left: 0, src: '', top: 0, width: 0, scale: 100});
  const [prevPage, setPrevPage] = React.useState({tracking: false, x: 0, y: 0});

  const { request } = props.context.getStates();

  const canvas256 = React.useRef(null);

  function handleMouseDown(event) {
    event.preventDefault();
    setPrevPage({...prevPage,
      tracking: true,
      x: event.pageX,
      y: event.pageY,
    });
  }

  function handleMouseMove(event) {
    event.preventDefault();
    if (prevPage.tracking) {
      setImage({...image,
        left: image.left + (event.pageX - prevPage.x),
        top: image.top + (event.pageY - prevPage.y)
      });
      setPrevPage({...prevPage,
        x: event.pageX,
        y: event.pageY,
      });
    }
  }

  function previewPicture(event) {
    //setPrevPage({tracking: false, x: 0, y: 0});
    const tmpImage = new Image();
    tmpImage.onload = function() {
      setImage({...image,
        height: this.height,
        left: 0,
        scale: 100,
        src: this.src,
        top: 0,
        width: this.width,
      });
    }
    const fileReader = new FileReader();
    fileReader.onload = function() {
      tmpImage.src = fileReader.result;
    }
    fileReader.readAsDataURL(event.target.files[0]);
  }

  const updateAttenderPicture = () => {
    var ctx256 = canvas256.current.getContext('2d');
    var cimage = new Image();
    cimage.onload = function() {
      ctx256.drawImage(this,
        -100 * (image.left - 65) / image.scale,
        -100 * (image.top - 65) / image.scale,
        25600 / image.scale,
        25600 / image.scale,
        0, 0, 256, 256
      );

      const picture256 = canvas256.current.toDataURL('image/jpeg', 1.0).split(';base64,')[1];

      request.postSecurely('/attender/update/picture', {
        attender: props.newPicture.attenderRowid,
        picture256,
      }, (response) => {
        if ('error' in response) {
          console.error(response);
        } else {
          props.setNewPicture(create.picture());
          props.setAttender((_attender) => ({
            ..._attender, picture256
          }))
        }
      });
    }
    cimage.src = image.src;
  }

  return (
    <Dialog open={props.newPicture.attenderRowid > -1}>
      <DialogContent className={classes.dialogContent}>
        <div style={{
          height: '386px',  // 256 + 64 * 2 + 1 * 2
          overflow: 'hidden',
          position: 'relative',
          width: '386px',
        }}>
          <canvas ref={canvas256} width={256} height={256} style={{display: 'none'}}></canvas>

          <img src={image.src} alt=''
            height={image.height * 0.01 * image.scale}
            style={{
              left: image.left,
              position: 'absolute',
              top: image.top,
            }}
            width={image.width * 0.01 * image.scale}

            onMouseDown={(event) => { handleMouseDown(event); }}
            onMouseMove={(event) => { handleMouseMove(event); }}
            onMouseOut={(event) => { setPrevPage({...prevPage, tracking: false}); }}
            onMouseUp={(event) => { setPrevPage({...prevPage, tracking: false}); }}
          />

          <div style={{
            border: '1px solid rgba(256, 256, 256, 0.5)',
            boxShadow: '0 0 0 64px rgba(0, 0, 0, 0.5)',
            height: '256px',
            left: '64px',
            pointerEvents: 'none',
            position: 'absolute',
            top: '64px',
            width: '256px',
          }}></div>
        </div>

        <div style={{
          position: 'absolute',
          right: 0,
          top: 0,
        }}>
          {image.src === '' ? (
            <IconButton component="label">
              <ImageIcon style={{color: 'white'}} />
              <input type="file" accept="image/*" hidden
                onChange={(event) => { previewPicture(event); }}
              />
            </IconButton>
          ) : (
            <IconButton onClick={() => {
              setImage({height: 0, left: 0, src: '', top: 0, width: 0, scale: 100});
            }}><CloseIcon style={{color: 'white'}} /></IconButton>
          )}
        </div>
      </DialogContent>

      <DialogContent>
        <Slider value={image.scale}
          ValueLabelComponent={(props) => {
            return (
              <Tooltip open={props.open} enterTouchDelay={0} placement="top" title={props.value + '%'}>
                {props.children}
              </Tooltip>
            );
          }}
          defaultValue={image.scale}
          onChange={(event, scale) => { setImage({...image, scale: scale});}}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={(event) => { props.setNewPicture(create.picture()); }}>{'취소'}</Button>
        <Button color="primary" onClick={(event) => { updateAttenderPicture(); }}>{'확인'}</Button>
      </DialogActions>
    </Dialog>
  );
}
